<template>
    <AppHead title="Veranstalter-Registrierung" />
    <div class="lg:px-64">
        <PageTitle>Veranstalter-Registrierung</PageTitle>
        <div class="w-full lg:flex items-start lg:space-x-8 mt-4">
            <div class="w-full lg:w-1/2">
                <ValidationErrors class="mb-4" />
                <form @submit.prevent="submit">
                    <div>
                        <FormLabel for="company" value="Veranstalter/Firma * (komplette Rechtsform)" />
                        <FormInput id="company" type="text" class="mt-1 block w-full" v-model="form.company" required autofocus autocomplete="organization" />
                    </div>
                    <div>
                        <FormLabel for="name" value="Name Ansprechpartner * (Titel/Vorname/Nachname)" />
                        <FormInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autocomplete="name" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="address" value="Straße/Hausnummer *" />
                        <FormInput id="address" type="text" class="mt-1 block w-full" v-model="form.address" required autocomplete="street-address" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="zip" value="PLZ *" />
                        <FormInput id="zip" type="text" class="mt-1 block w-full" v-model="form.zip" required autocomplete="postal-code" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="city" value="Ort *" />
                        <FormInput id="city" type="text" class="mt-1 block w-full" v-model="form.city" required autocomplete="address-level2" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="internet" value="Internet" />
                        <FormInput id="internet" type="url" class="mt-1 block w-full" v-model="form.internet" placeholder="z.B. https://www.kulturkalender-dresden.de" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="phone" value="Telefon" />
                        <FormInput id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" autocomplete="tel-national" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="email" value="E-Mail *" />
                        <FormInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="username" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="password" value="Passwort (mind. 8 Zeichen) *" />
                        <FormInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                    </div>
                    <div class="mt-4">
                        <FormLabel for="password_confirmation" value="Passwort wiederholen *" />
                        <FormInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                    </div>
                    <div class="block mt-4">
                        <label class="flex items-center">
                            <FormCheckbox type="checkbox" name="terms" v-model:checked="form.terms" />
                            <span class="ml-2 text-sm text-gray-600">
                                Ich akzeptiere die <a :href="route('manager.terms')" target="_blank">Nutzungsbedingungen</a> des Kulturkalenders Dresden *
                            </span>
                        </label>
                    </div>
                    <div class="flex items-center justify-end mt-4">
                        <Link :href="route('manager.login')" class="text-sm">
                            Bereits registriert?
                        </Link>
                        <FormButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Registrieren
                        </FormButton>
                    </div>
                </form>
            </div>
            <div class="w-full lg:w-1/2 mt-4 lg:mt-0">
                <p>
                    Willkommen auf der Registrierungsseite des Kulturkalenders Dresden für Veranstalter. Bitte füllen Sie alle erforderlichen Felder aus und bestätigen Sie die Nutzungsbedingungen. Sobald Sie auf den Button „Registrieren“ klicken, erhalten Sie eine Mail zur Bestätigung Ihrer Mail-Adresse. Prüfen Sie ggf. auch Ihren SPAM-Ordner wenn Sie den Bestätigungslink nicht erhalten haben.
                    Bitte beachten Sie: Erst nachdem wir Sie in unserem System freigeschalten haben, können Sie den Kuka-Manager nutzen und selbst Veranstaltungen eintragen. Sie erhalten nach erfolgter Bestätigung eine Mail von uns. Dies kann max. 24h in Anspruch nehmen.
                    Für Fragen wenden Sie sich bitte per Mail an: <a href="mailto:kuka-manager@kulturkalender-dresden.de" class="whitespace-nowrap">kuka-manager@kulturkalender-dresden.de</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { Link, useForm } from "@inertiajs/vue3";
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import ValidationErrors from '@/Shared/Form/ValidationErrors';
import FormLabel from '@/Shared/Form/Label';
import FormInput from '@/Shared/Form/Input';
import FormButton from '@/Shared/Form/Button';
import FormCheckbox from '@/Shared/Form/Checkbox';

const form = useForm({
    company: '',
    name: '',
    address: '',
    zip: '',
    city: '',
    email: '',
    internet: '',
    phone: '',
    password: '',
    password_confirmation: '',
    terms: false,
});
const submit = () => {
    form.post(route('manager.register'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>
